if (!customElements.get('keene-header')) customElements.define('keene-header', class extends HTMLElement {
  connectedCallback() {
    this.onScroll = () => {
      if (window.scrollY > 104) this.classList.add('is-compact');
      else if (window.scrollY < 32) this.classList.remove('is-compact');
    };
    this.renderCount = (cart) => {
      if (!Number.isFinite(cart?.item_count)) return;
      const count = Math.max(0, cart.item_count);
      const badge = this.querySelector('[data-keene-header-count]');
      badge.textContent = count > 99 ? '99+' : String(count);
      badge.hidden = count === 0;
      this.querySelector('[data-keene-header-cart]').setAttribute('aria-label', `${this.dataset.cartLabel}: ${count}`);
    };
    this.onCart = (event) => this.renderCount(event.detail?.cart);
    this.unsubscribe = window.FoxTheme?.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, ({ cart }) => this.renderCount(cart));
    for (const name of ['cart:updated', 'keene:cart-updated']) document.addEventListener(name, this.onCart);
    this.onPageShow = () => fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, { cache: 'no-store' }).then((r) => r.ok ? r.json() : null).then(this.renderCount).catch(() => {});
    this.isDesktop = () => window.matchMedia('(min-width: 750px)').matches;
    this.searchToggle = this.querySelector('.keene-header__search-toggle');
    this.closeSearch = ({ returnFocus = false } = {}) => {
      const search = this.querySelector('predictive-search');
      search?.toggleSearchState?.(false);
      search?.classList.remove('predictive-search-open');
      search?.querySelector('.search__content')?.classList.add('hidden');
      search?.querySelector('input')?.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('search-open');
      this.removeAttribute('data-search-open');
      this.searchToggle?.setAttribute('aria-expanded', 'false');
      if (returnFocus && this.isDesktop()) this.searchToggle?.focus({ preventScroll: true });
    };
    this.openSearch = () => {
      if (!this.isDesktop()) return;
      this.setAttribute('data-search-open', 'true');
      this.searchToggle?.setAttribute('aria-expanded', 'true');
      requestAnimationFrame(() => this.querySelector('input[type="search"]')?.focus({ preventScroll: true }));
    };
    this.onKeydown = (event) => {
      if (event.key === 'Escape' && (event.target.closest('predictive-search') || this.hasAttribute('data-search-open'))) {
        event.preventDefault();
        this.closeSearch({ returnFocus: true });
      }
    };
    this.onClick = (event) => {
      if (event.target.closest('.keene-header__search-toggle')) this.openSearch();
      if (event.target.closest('.header__search-close')) this.closeSearch({ returnFocus: true });
    };
    this.onOutside = (event) => { if (!this.contains(event.target)) this.closeSearch(); };
    const search = this.querySelector('predictive-search');
    if (search) {
      this.searchObserver = new MutationObserver(() => {
        search.querySelector('input[type="search"]')?.setAttribute('aria-expanded', String(search.classList.contains('predictive-search-open') && !search.querySelector('.search__content')?.classList.contains('hidden')));
      });
      this.searchObserver.observe(search, { attributes: true, attributeFilter: ['class'], subtree: true });
    }
    this.addEventListener('keydown', this.onKeydown);
    this.addEventListener('click', this.onClick);
    document.addEventListener('click', this.onOutside);
    window.addEventListener('scroll', this.onScroll, { passive: true });
    window.addEventListener('pageshow', this.onPageShow);
    this.resize = new ResizeObserver(() => {
      const height = Math.ceil(this.getBoundingClientRect().height);
      document.documentElement.style.setProperty('--header-height', `${height}px`);
      document.documentElement.style.setProperty('--header-offset-top', '0px');
      document.documentElement.style.setProperty('--header-navigation-height', '0px');
    });
    this.resize.observe(this);
    this.onScroll();
  }
  disconnectedCallback() {
    this.unsubscribe?.();
    for (const name of ['cart:updated', 'keene:cart-updated']) document.removeEventListener(name, this.onCart);
    window.removeEventListener('scroll', this.onScroll);
    window.removeEventListener('pageshow', this.onPageShow);
    document.removeEventListener('click', this.onOutside);
    this.removeEventListener('keydown', this.onKeydown);
    this.removeEventListener('click', this.onClick);
    this.resize?.disconnect();
    this.searchObserver?.disconnect();
  }
});
